import { render, staticRenderFns } from "./Ssqbz.vue?vue&type=template&id=05b4f06c&scoped=true"
import script from "./Ssqbz.vue?vue&type=script&lang=js"
export * from "./Ssqbz.vue?vue&type=script&lang=js"
import style0 from "./Ssqbz.vue?vue&type=style&index=0&id=05b4f06c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4f06c",
  null
  
)

export default component.exports